<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Insight</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Insight</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addInsightsForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control" id="category_id" formControlName="category_id">
                                            <option value="">Select Category</option>
                                            <option [value]="insightscateogry?.id"
                                                    *ngFor="let insightscateogry of insightsCategory">{{ insightscateogry.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addInsightsForm.get('category_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Sub Category</label>

                                        <select class="form-control" id="subcategory_id"
                                                formControlName="subcategory_id">
                                            <option value="">Select Sub Category</option>
                                            <option [value]="insightssubcateogry?.id"
                                                    *ngFor="let insightssubcateogry of insightsSubCategory">{{ insightssubcateogry.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addInsightsForm.get('subcategory_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Heading</label>
                                        <input class="form-control" id="heading" type="text" formControlName="heading">
                                        <small *ngIf="submitted && addInsightsForm.get('heading').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="heading">Url</label>
                                        <input class="form-control" id="url" type="text" formControlName="url">
                                        <small *ngIf="submitted && addInsightsForm.get('url').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="author">Author</label>
                                        <ng-select
                                                [items]="authors"
                                                bindLabel="name"
                                                bindValue="name"
                                                placeholder="Select Author"
                                                formControlName="author"
                                                (change)="onAuthorChange($event)">
                                            <ng-template ng-label-tmp let-item="item">
                                                <img *ngIf="item?.profile_photo?.url" [src]="item.profile_photo.url"
                                                     class="rounded-circle mr-1 author-avatar" alt="">
                                                <i *ngIf="!item?.profile_photo?.url"
                                                   class="fas fa-user-circle mr-1 author-avatar-placeholder"></i>
                                                <span>{{item.name}}</span>
                                            </ng-template>
                                            <ng-template ng-option-tmp let-item="item">
                                                <img *ngIf="item?.profile_photo?.url" [src]="item.profile_photo.url"
                                                     class="rounded-circle mr-1 author-avatar" alt="">
                                                <i *ngIf="!item?.profile_photo?.url"
                                                   class="fas fa-user-circle mr-1 author-avatar-placeholder"></i>
                                                <span>{{item.name}}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="publish_date">Publish Date</label>
                                        <input class="form-control resize-none w-100" id="publish_date" type="date"
                                               formControlName="publish_date"/>
                                        <small *ngIf="submitted && addInsightsForm.get('publish_date').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="short_description">Short Description</label>
                                        <textarea class="form-control resize-none" id="short_description" type="text"
                                                  formControlName="short_description"></textarea>
                                        <small *ngIf="submitted && addInsightsForm.get('short_description').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_title">Meta Title</label>
                                        <textarea class="form-control resize-none" id="meta_title" type="text"
                                                  formControlName="meta_title"></textarea>
                                        <small *ngIf="submitted && addInsightsForm.get('meta_title').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_description">Meta Description</label>
                                        <textarea class="form-control resize-none" id="meta_description" type="text"
                                                  formControlName="meta_description"></textarea>
                                        <small *ngIf="submitted && addInsightsForm.get('meta_description').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="meta_keyword">Meta Keywords</label>
                                        <textarea class="form-control resize-none" id="meta_keyword" type="text"
                                                  formControlName="meta_keyword"></textarea>
                                        <small *ngIf="submitted && addInsightsForm.get('meta_keyword').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button type="button" rippleEffect class="btn btn-danger" data-dismiss="modal"
                                            aria-label="Close" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>

